import requestWrapper from '../shared/lib/requestWrapper';
import constants from '../shared/constants';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/AnthropometricEvaluation',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function update(payload) {
    var response = await requestWrapper({
        url:    '/AnthropometricEvaluation/' + payload.data.id,
        method: 'PUT',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function getByAppointmentId(payload) {
    var response = await requestWrapper({
        url:    '/AnthropometricEvaluation/appointment/' + payload.data.idAppointment,
        method: 'GET',
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function getByPatientId(payload) {
    var response = await requestWrapper({
        url:    '/AnthropometricEvaluation/patient/' + payload.data.idPatient,
        method: 'GET',
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

const AnthropometricEvaluationService = {
    create, update, getByAppointmentId, getByPatientId
}

export default AnthropometricEvaluationService;